// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__156zM","label":"LabeledBox_label__yOLpj"};